export default __webpack_public_path__ + "static/media/logo.a0be1bbd.png";